module.exports = __webpack_public_path__ + "static/why1-2bd1940562d9a9bd89ed8d34c6465f23.jpg";